const VOUCHER_TYPE = {
	POINT: 'POINT',
	TICKET: 'TICKET'
}

export { VOUCHER_TYPE }
